import { render } from "./TheRGPDAcceptanceResponse.vue?vue&type=template&id=57c3c434&ts=true"
import script from "./TheRGPDAcceptanceResponse.vue?vue&type=script&lang=ts"
export * from "./TheRGPDAcceptanceResponse.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__